import { Button, Skeleton, useMediaQuery } from "@mui/material";
import { Box, Container } from "@mui/system";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import he from 'he';

export default function ScrollMenu({items, loading, services}){

    const mobile=useMediaQuery(theme=>theme.breakpoints.down('md'));

    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        if (element) {
            const offset = -130;
            const targetScrollPosition = element.offsetTop + offset;

            window.scrollTo({
                top: targetScrollPosition,
                behavior: "smooth"
            });
        }
    };

    return(
        <>
            {loading?
                <Skeleton
                    variant='rectangular'
                    height='60px'
                    sx={{
                        m:0,
                    }}
                />
            :
                <Box
                    sx={{
                        backgroundColor:'#F0F0F0'
                    }}
                >
                    <Container maxWidth='xl'
                        sx={{
                            display:'flex',
                            flexDirection:{
                                xs:'column',
                                md:'row'
                            }
                        }}
                    >
                        {items && items.map((item)=>{
                            return(
                                <Button
                                    to={item.url}
                                    onClick={() => scrollToElement(item.url)}
                                    sx={{
                                        p:{
                                            xs:'0.5rem 1rem',
                                            md:'1rem 2rem'
                                        },
                                        color:'#1B314A',
                                        fontSize:'1rem',
                                        borderBottom:{
                                            xs:'1px solid #c0c0c0',
                                            md:'none'
                                        },
                                        borderRadius:0,
                                        backgroundColor: item.current_page? 'rgba(0, 0, 0, 0.1)' : 'none',
                                        '&:hover':{
                                            backgroundColor:'rgba(0, 0, 0, 0.1)'
                                        }
                                    }}
                                >
                                    {he.decode(item.title)}
                                </Button>
                            );
                        })}
                        <Button 
                            component={RouterLink}
                            to={'/contact/'}
                            sx={{
                                p:{
                                    xs:'0.5rem 1rem',
                                    md:'1rem 2rem'
                                },
                                color:'#1B314A',
                                fontSize:'1rem',
                                borderRadius:0,
                                '&:hover':{
                                    backgroundColor:'rgba(0, 0, 0, 0.1)'
                                }
                            }}
                        >
                            Book a Demo
                        </Button>
                    </Container>
                </Box>
            }
        </>
    );
}